import React, { useState } from "react";


import Shape from '../../images/contact-main.png'
import SimpleReactValidator from "simple-react-validator";

const Contactpage = () => {

    const [forms, setForms] = useState({
        name: '',
        email: '',
        phone: '',
        textarea: '',
    });
    const [validator] = useState(new SimpleReactValidator({
        className: 'errorMessage',
        messages: {
            required: ':attribute 항목은 필수입니다.',
            email: '올바른 이메일 형식을 입력해주세요.',
            phone: '올바른 연락처 형식을 입력해주세요.',
            alpha_space: '이름은 한글 또는 영문만 입력 가능합니다.',
            min: ':attribute은(는) 최소 :min자 이상 입력해주세요.',
            max: ':attribute은(는) 최대 :max자까지 입력 가능합니다.',
        },
        validators: {
            alpha_space: {
                message: '이름은 한글 또는 영문만 입력 가능합니다.',
                rule: (val) => /^[가-힣a-zA-Z\s]+$/.test(val),
            },
        },
    }));
    const changeHandler = e => {
        setForms({ ...forms, [e.target.name]: e.target.value })
        if (validator.allValid()) {
            validator.hideMessages();
        } else {
            validator.showMessages();
        }
    };
    const submitHandler = e => {
        e.preventDefault();
        if (validator.allValid()) {
            validator.hideMessages();
            setForms({
                name: '',
                email: '',
                phone: '',
                textarea: '',
            })
        } else {
            validator.showMessages();
        }
    }



    return (
        <div>
            <section className="contact-page section-padding">
                <div className="container">
                    {/* <div className="office-info">
                        <div className="row">
                            <div className="col col-lg-4 col-md-6 col-12">
                                <div className="office-info-item">
                                    <div className="office-info-icon">
                                        <div className="icon">
                                            <i className="fi flaticon-placeholder"></i>
                                        </div>
                                    </div>
                                    <div className="office-info-text">
                                        <h2>address line</h2>
                                        <p>Bowery St, New York, 37 USA
                                            <br /> NY 10013,USA</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lg-4 col-md-6 col-12">
                                <div className="office-info-item active">
                                    <div className="office-info-icon">
                                        <div className="icon">
                                            <i className="fi flaticon-phone-call"></i>
                                        </div>
                                    </div>
                                    <div className="office-info-text">
                                        <h2>Phone Number</h2>
                                        <p>+1255 - 568 - 6523 4374-221 <br />
                                            +1255 - 568 - 6523</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lg-4 col-md-6 col-12">
                                <div className="office-info-item">
                                    <div className="office-info-icon">
                                        <div className="icon">
                                            <i className="fi flaticon-email"></i>
                                        </div>
                                    </div>
                                    <div className="office-info-text">
                                        <h2>Address</h2>
                                        <p>contact@pixor.com <br /> info@pixor.com</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="contact-wrap">
                        <div className="row">
                            <div className="col-lg-6 col-12">
                                <div className="contact-left" style={{maxWidth: "100%", overflow: "hidden"}}>
                                    <h2>Contact</h2>
                                    <p style={{color:"#000"}}>
                                        항상 고객사와의 상생을 최우선 가치로 { (window.innerWidth < 400 ) && <br /> } 상정하여 { (window.innerWidth > 400 && window.innerWidth < 768) && <br /> } 신뢰를 바탕으로 { window.innerWidth >= 1200 ? <br /> : " " }
                                        고객가치를 높여 { (window.innerWidth < 400 ) && <br /> } 나가는 일에  { (window.innerWidth > 400 && window.innerWidth < 768) && <br /> } 최선을 다하여 왔습니다.
                                    </p>
                                    <img className="image" src={Shape} alt="" style={{maxWidth: "100%", height: "auto"}} />
                                </div>
                            </div>
                            <div className="col-lg-6 col-12">
                                <div className="contact-right">
                                    <div className="title">
                                        {/* <h2>Contact</h2> */}
                                        <p style={{color:"#51555C", fontSize: "20px", fontStyle: "normal", fontWeight: "600", lineHeight: "normal", letterSpacing: "-1px"}}>제휴 관련 문의를 남겨주시면 { window.innerWidth >= 1200 ? <br /> : " " } 검토 후 { window.innerWidth >= 1200 ? " " : <br /> } 담당 부서에서 순차적으로 연락드리겠습니다.</p>
                                    </div>

                                    <form id="form1" className="contact-form" onSubmit={submitHandler}>
                                        <div className="input-item">
                                            <input className="fild" value={forms.name}
                                                type="text"
                                                name="name"
                                                onBlur={(e) => changeHandler(e)}
                                                onChange={(e) => changeHandler(e)} placeholder="이름*" />
                                            <label><i className="flaticon-user"></i></label>
                                            {validator.message('이름', forms.name, 'required|alpha_space')}
                                        </div>
                                        <div className="input-item">
                                            <input className="fild" placeholder="이메일*" value={forms.email}
                                                type="email"
                                                name="email"
                                                onBlur={(e) => changeHandler(e)}
                                                onChange={(e) => changeHandler(e)} />
                                            <label><i className="flaticon-email"></i></label>
                                            {validator.message('이메일', forms.email, 'required|email')}
                                        </div>
                                        <div className="input-item">
                                            <input className="fild" placeholder="연락처*" value={forms.phone}
                                                type="tel"
                                                name="phone"
                                                onBlur={(e) => changeHandler(e)}
                                                onChange={(e) => changeHandler(e)} />
                                            <label><i className="flaticon-phone-call"></i></label>
                                            {validator.message('연라처', forms.phone, 'required|phone')}
                                        </div>
                                        <div className="input-item">
                                            <textarea
                                                className="fild textarea"
                                                placeholder="내용*"
                                                value={forms.textarea}
                                                name="textarea"
                                                onBlur={() => validator.showMessageFor("textarea")}
                                                onChange={changeHandler}
                                            ></textarea>
                                            <label><i className="ti-new-window"></i></label>
                                            {validator.message("내용", forms.textarea, "required|min:10|max:500")}
                                        </div>
                                        <div className="input-item submitbtn">
                                            <button className="fild" type="submit">문의하기</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <section className="map-section">
                <h2 className="hidden">Contact map</h2>
                <div className="wpo-map">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d193595.9147703055!2d-74.11976314309273!3d40.69740344223377!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew+York%2C+NY%2C+USA!5e0!3m2!1sen!2sbd!4v1547528325671"
                        allowFullScreen></iframe>
                </div>
            </section> */}

        </div>
    )

}

export default Contactpage;


